/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const postUsersPreferencesUnitsStatus201Schema = z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})

export const postUsersPreferencesUnitsStatus400Schema = z.string()

export const postUsersPreferencesUnitsStatus401Schema = z.string()

export const postUsersPreferencesUnitsStatus409Schema = z.string()

export const postUsersPreferencesUnitsStatus500Schema = z.string()

export const postUsersPreferencesUnitsResponseSchema = postUsersPreferencesUnitsStatus201Schema

export const postUsersPreferencesUnitsErrorSchema = z.union([postUsersPreferencesUnitsStatus400Schema, postUsersPreferencesUnitsStatus401Schema, postUsersPreferencesUnitsStatus409Schema, postUsersPreferencesUnitsStatus500Schema])

export const postUsersPreferencesUnitsBodySchema = z.object({
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
}).optional()
